import { gql } from '@apollo/client';

export const RESET_CUSTOMER_TWO_FA = gql`
  mutation ResetCustomerTwoFA($input: ResetCustomerTwoFAInput!) {
    resetCustomerTwoFA(input: $input) {
      status
      message
    }
  }
`;
